<template>
  <div class="map-view-div">
    <GmapMap
        :center="mapCenter"
        :zoom="14"
        :options="mapStyle"
        @dragstart="onDragStarted"
        map-type-id="terrain"
        style="width: 100%; height: 100%"
    >
      <GmapCustomMarker
          :key="index"
          v-for="(m, index) in markers"
          :marker="m.position"
      >
        <img v-if="m.id === userLocationMarkerId" v-bind:src="m.icon">
        <img v-else style="height:72px; width:72px" v-bind:src="m.icon">
      </GmapCustomMarker>
    </GmapMap>

    <div class="logout-btn">
      <b-button class="fab-btn" @click="this.logout">
        <img style="height: 24px; width: 24px; margin-right: 4px" src="../assets/images/sign-out.svg" aria-hidden="true">
      </b-button>
    </div>
    <div class="scooter-location-fab">
      <b-button class="fab-btn" @click="this.followScooterLocation" :disabled="shouldFollowScooterGeoLocation">
        <img style="height: 24px; width: 24px" src="../assets/images/gps.svg" aria-hidden="true">
      </b-button>
    </div>
    <StartStopFab
        v-if="selectedMarker"
        v-bind:vehicle="selectedMarker"
        @startStopProcessingChanged="onStartStopProcessingChanged"
    />
    <vehicle-details-bar
      v-if="selectedMarker"
      v-bind:vehicle="selectedMarker"
    />
  </div>
</template>

<script>
  import VehicleDetailsBar from "@/components/VehicleDetailsBar";
  import StartStopFab from "@/components/StartStopFab";
  import { firebaseAuth, firestore } from "@/firebase";
  import store from "@/store";
  import GmapCustomMarker from 'vue2-gmap-custom-marker';

  export default {
    name: "MapView",
    components: {
      VehicleDetailsBar,
      GmapCustomMarker,
      StartStopFab
    },
    data() {
      return {
        userLocationMarkerId: 'user-geolocation',
        mapCenter: { lat: 59.436990, lng: 24.753468 },
        userPosition: null,
        selectedMarker: null,
        markers: [],
        shouldFollowUserGeoLocation: true,
        shouldFollowScooterGeoLocation: false,
        userGeolocationUpdaterInterval: null,
        unsubscribeVehicleQuery: null,
        unsubscribeUserListener: null,
        mapStyle: {
          disableDefaultUI: true,
          clickableIcons: false,
          gestureHandling: 'greedy',
          styles: [  {  "elementType":  "labels.text",  "stylers":  [  {  "lightness":  40  }  ]  },  {  "featureType":  "administrative",  "elementType":  "labels.text.fill",  "stylers":  [  {  "color":  "#5d5d5f"  }  ]  },  {  "featureType":  "landscape",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#e2e4e9"  },  {  "lightness":  65  },  {  "visibility":  "on"  }  ]  },  {  "featureType":  "landscape",  "elementType":  "geometry.stroke",  "stylers":  [  {  "color":  "#dfe1e7"  },  {  "weight":  1.5  }  ]  },  {  "featureType":  "poi",  "elementType":  "labels",  "stylers":  [  {  "visibility":  "off"  }  ]  },  {  "featureType":  "poi",  "elementType":  "labels.icon",  "stylers":  [  {  "lightness":  80  },  {  "visibility":  "off"  }  ]  },  {  "featureType":  "poi",  "elementType":  "labels.text.fill",  "stylers":  [  {  "color":  "#030303"  },  {  "visibility":  "off"  }  ]  },  {  "featureType":  "poi",  "elementType":  "labels.text.stroke",  "stylers":  [  {  "visibility":  "off"  }  ]  },  {  "featureType":  "poi.attraction",  "elementType":  "geometry",  "stylers":  [  {  "color":  "#f0f0f0"  },  {  "visibility":  "on"  }  ]  },  {  "featureType":  "poi.attraction",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "poi.business",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "poi.government",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "poi.medical",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "poi.park",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#e2f3e9"  }  ]  },  {  "featureType":  "poi.place_of_worship",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "poi.school",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "poi.sports_complex",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#f0f0f0"  }  ]  },  {  "featureType":  "road",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#ffffff"  }  ]  },  {  "featureType":  "road",  "elementType":  "geometry.stroke",  "stylers":  [  {  "color":  "#ffffff"  }  ]  },  {  "featureType":  "road",  "elementType":  "labels",  "stylers":  [  {  "visibility":  "simplified"  }  ]  },  {  "featureType":  "road",  "elementType":  "labels.text",  "stylers":  [  {  "lightness":  10  }  ]  },  {  "featureType":  "road.highway",  "elementType":  "labels",  "stylers":  [  {  "visibility":  "off"  }  ]  },  {  "featureType":  "road.highway",  "elementType":  "labels.text.fill",  "stylers":  [  {  "color":  "#6d6d6f"  }  ]  },  {  "featureType":  "transit",  "elementType":  "labels",  "stylers":  [  {  "visibility":  "off"  }  ]  },  {  "featureType":  "transit.line",  "elementType":  "geometry",  "stylers":  [  {  "visibility":  "off"  }  ]  },  {  "featureType":  "water",  "elementType":  "geometry.fill",  "stylers":  [  {  "color":  "#d5e8f6"  }  ]  },  {  "featureType":  "water",  "elementType":  "labels.text",  "stylers":  [  {  "color":  "#000000"  }  ]  },  {  "featureType":  "water",  "elementType":  "labels.text.fill",  "stylers":  [  {  "color":  "#000000"  }  ]  }  ]
        }
      }
    },
    beforeCreate() {
      let unsubscribe = store.watch(() => store.getters['user'], user => {
        unsubscribe();
        if (!user || !user.vehicle)
          return this.$router.push({ name: 'Register vehicle' })
      });
    },
    created() {
      let user = store.getters.user;
      if (user) {
        this.subscribeToUserVehicle(user.vehicle);
      } else {
        this.unsubscribeUserListener = store.watch(() => store.getters['user'], user => {
          if (!user || !user.vehicle) return;
          this.subscribeToUserVehicle(user.vehicle);
        });
      }
    },
    mounted() {
      this.userGeolocationUpdaterInterval = setInterval(() => this.updateUserGeolocation(), 1000);
    },
    beforeDestroy() {
      clearInterval(this.userGeolocationUpdaterInterval);
      this.unsubscribeVehicleQuery && this.unsubscribeVehicleQuery();
      this.unsubscribeUserListener && this.unsubscribeUserListener();
    },
    methods: {
      subscribeToUserVehicle(vehicleId) {
        this.unsubscribeVehicleQuery = firestore.collection('vehicles').doc(vehicleId)
            .onSnapshot(vehicleSnapshot => {
              if (!vehicleSnapshot.exists)
                return this.markers = [];

              let marker = this.mapDocumentSnapshotToMarker(vehicleSnapshot);
              if (!this.updateMarkerIfPresent(marker)) {
                this.openVehicleDetailView(marker);
                this.markers.push(marker);
              }
              if (this.shouldFollowScooterGeoLocation)
                this.mapCenter = marker.position;

            });
      },
      updateUserGeolocation() {
        navigator.geolocation.getCurrentPosition(position => {
          let userGeolocationMarker = {
            id: this.userLocationMarkerId,
            position: {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            },
            markerOptions: {
              size: {width: 60, height: 60, f: 'px', b: 'px'},
              scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
              url: require('../assets/images/bluedot.png')
            },
            icon: require('../assets/images/bluedot.png')
          };
          this.userPosition = userGeolocationMarker.position;
          if (!this.updateMarkerIfPresent(userGeolocationMarker)) {
            this.markers.push(userGeolocationMarker);
            this.mapCenter = userGeolocationMarker.position;
          }
          if (this.shouldFollowUserGeoLocation)
            this.mapCenter = userGeolocationMarker.position;
        });
      },
      onStartStopProcessingChanged(value) {
        const vehicleId = value.vehicleId;
        const isProcessing = value.isProcessing;
        let marker = this.markers.find(m => m.id === vehicleId);
        if (isProcessing)
          marker.icon = require('../assets/images/scooter-processing-2x.png');
        else marker.icon = this.getMarkerIconSource(marker);
      },
      mapDocumentSnapshotToMarker(vehicleSnapshot) {
        let marker = {
          id: vehicleSnapshot.id,
          code: vehicleSnapshot.data().code,
          odometer: vehicleSnapshot.data().odometer,
          soc: vehicleSnapshot.data().soc,
          batOneSoc: vehicleSnapshot.data().batOneSoc,
          batTwoSoc: vehicleSnapshot.data().batTwoSoc,
          position: { lat: vehicleSnapshot.data().location.lat, lng: vehicleSnapshot.data().location.lon },
          poweredOn: vehicleSnapshot.data().poweredOn,
        };
        marker.icon = this.getMarkerIconSource(marker);
        return marker;
      },
      updateMarkerIfPresent(markerToUpdate) {
        if (this.selectedMarker && (this.selectedMarker.id === markerToUpdate.id))
          this.selectedMarker = markerToUpdate;

        for (let marker of this.markers) {
          if (marker.id === markerToUpdate.id) {
            marker.position = markerToUpdate.position;
            marker.markerOptions = markerToUpdate.markerOptions;
            marker.poweredOn = markerToUpdate.poweredOn;
            marker.icon = markerToUpdate.icon;
            return true;
          }
        }
        return false;
      },
      getMarkerIconSource(marker) {
        console.log(marker.id)
        if (marker.id === this.userLocationMarkerId)
          return require('../assets/images/bluedot.png');
        else if (marker.poweredOn)
          return require('../assets/images/scooter-unlocked-2x.png')
        else return require('../assets/images/scooter-locked-2x.png')
      },
      openVehicleDetailView(marker) {
        this.selectedMarker = marker;
      },
      followScooterLocation() {
        this.hackMapCenterLat();

        this.mapCenter = this.selectedMarker.position;
        this.shouldFollowUserGeoLocation = false;
        this.shouldFollowScooterGeoLocation = true;
      },
      onDragStarted() {
        this.hackMapCenterLat();
        this.shouldFollowUserGeoLocation = false;
        this.shouldFollowScooterGeoLocation = false;
      },
      hackMapCenterLat() { // TODO Should be fixed. Hack for the mapCenter to work properly when setting to exact same coordinates
        this.mapCenter.lat += 0.0000001
      },
      async logout() {
        await firebaseAuth.signOut();
        await this.$router.push({ name: 'Login' })
      }
    }
  }
</script>

<style scoped>
  .map-view-div {
    height: 100vh;
    position: relative;
  }
  .scooter-location-fab {
    padding: 0;
    position: fixed;
    height: auto;
    width: auto;
    top: 115px;
    left: 20px;
  }
  .logout-btn {
    padding: 0;
    margin: 40px 0 0 20px;
    position: fixed;
    height: auto;
    width: auto;
    top: 0;
  }
  .fab-btn {
    background-color: rgba(255,255,255,1);
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 3px 4px 16px rgba(100,106,108,0.204);
    height: 52px;
    width: 52px;
    border: none;
    border-radius: 50%;
    stroke: rgba(237,237,242,1);
    stroke-width: 1px;
    stroke-linejoin: miter;
    stroke-linecap: butt;
    stroke-miterlimit: 4;
    shape-rendering: auto;
    color: rgba(0,0,0,1);
  }
  .fab-btn:hover {
    background-color: rgba(255,255,255,1);
  }
  .fab-btn:active {
    background-color: rgba(173,175,181,1);
  }
  .fab-btn:disabled {
    background-color: rgba(173,175,181,1);
  }
</style>
